<template>
  <v-app>
    <v-content>
      <router-view></router-view>
      <Snackbar />
      <FabButtonWhatsApp />
    </v-content>
  </v-app>
</template>

<script>
import Snackbar from '@/components/Snackbar';
import FabButtonWhatsApp from '@/components/FabButtonWhatsApp'

export default {
  name: 'App',
  components: {
    Snackbar,
    FabButtonWhatsApp,
  },
  mounted() {
    // Para o dialog
    this.$root.$confirm = this.$refs.confirm.open;
  },
};
</script>

<style lang="scss">
.theme--light.application {
  background: #ffffff;
  color: #6f6f6f;
}
</style>
